// extracted by mini-css-extract-plugin
export default {"fileAttachmentsList":"_7IqFxppWwB9IcMhcAE-uVw==","singleImageView":"ejqmCz96o0WQWY-MHtioTA=="};